import { useMemo } from 'react';
import { useUserLocation } from '@/hooks/useUserLocation';
import { resolveSupportContact, SupportContact } from '@/utils/supportContact';

/**
 * The support contact for the member's own box, with the Tee Box general
 * email/number as the fallback. See `resolveSupportContact` for the order.
 *
 * `useUserLocation` serves from localStorage before the network, so the Help
 * Center renders the member's box immediately on a warm start rather than
 * flashing the generic details first.
 */
export function useSupportContact(): SupportContact {
  const { location } = useUserLocation();
  return useMemo(() => resolveSupportContact(location), [location]);
}
